package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets14 {
  internal val _38_divrei_hayamim_a_29_txt: AssetResource by lazy {
      init__38_divrei_hayamim_a_29_txt() }

  internal val _39_divrei_hayamim_b_01_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_01_txt() }

  internal val _39_divrei_hayamim_b_02_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_02_txt() }

  internal val _39_divrei_hayamim_b_03_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_03_txt() }

  internal val _39_divrei_hayamim_b_04_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_04_txt() }

  internal val _39_divrei_hayamim_b_05_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_05_txt() }

  internal val _39_divrei_hayamim_b_06_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_06_txt() }

  internal val _39_divrei_hayamim_b_07_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_07_txt() }

  internal val _39_divrei_hayamim_b_08_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_08_txt() }

  internal val _39_divrei_hayamim_b_09_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_09_txt() }

  internal val _39_divrei_hayamim_b_10_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_10_txt() }

  internal val _39_divrei_hayamim_b_11_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_11_txt() }

  internal val _39_divrei_hayamim_b_12_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_12_txt() }

  internal val _39_divrei_hayamim_b_13_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_13_txt() }

  internal val _39_divrei_hayamim_b_14_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_14_txt() }

  internal val _39_divrei_hayamim_b_15_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_15_txt() }

  internal val _39_divrei_hayamim_b_16_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_16_txt() }

  internal val _39_divrei_hayamim_b_17_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_17_txt() }

  internal val _39_divrei_hayamim_b_18_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_18_txt() }

  internal val _39_divrei_hayamim_b_19_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_19_txt() }

  internal val _39_divrei_hayamim_b_20_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_20_txt() }

  internal val _39_divrei_hayamim_b_21_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_21_txt() }

  internal val _39_divrei_hayamim_b_22_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_22_txt() }

  internal val _39_divrei_hayamim_b_23_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_23_txt() }

  internal val _39_divrei_hayamim_b_24_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_24_txt() }

  internal val _39_divrei_hayamim_b_25_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_25_txt() }

  internal val _39_divrei_hayamim_b_26_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_26_txt() }

  internal val _39_divrei_hayamim_b_27_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_27_txt() }

  internal val _39_divrei_hayamim_b_28_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_28_txt() }

  internal val _39_divrei_hayamim_b_29_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_29_txt() }

  internal val _39_divrei_hayamim_b_30_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_30_txt() }

  internal val _39_divrei_hayamim_b_31_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_31_txt() }

  internal val _39_divrei_hayamim_b_32_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_32_txt() }

  internal val _39_divrei_hayamim_b_33_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_33_txt() }

  internal val _39_divrei_hayamim_b_34_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_34_txt() }

  internal val _39_divrei_hayamim_b_35_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_35_txt() }

  internal val _39_divrei_hayamim_b_36_txt: AssetResource by lazy {
      init__39_divrei_hayamim_b_36_txt() }

  internal val _3_vayikra_01_txt: AssetResource by lazy { init__3_vayikra_01_txt() }

  internal val _3_vayikra_02_txt: AssetResource by lazy { init__3_vayikra_02_txt() }

  internal val _3_vayikra_03_txt: AssetResource by lazy { init__3_vayikra_03_txt() }

  internal val _3_vayikra_04_txt: AssetResource by lazy { init__3_vayikra_04_txt() }

  internal val _3_vayikra_05_txt: AssetResource by lazy { init__3_vayikra_05_txt() }

  internal val _3_vayikra_06_txt: AssetResource by lazy { init__3_vayikra_06_txt() }

  internal val _3_vayikra_07_txt: AssetResource by lazy { init__3_vayikra_07_txt() }

  internal val _3_vayikra_08_txt: AssetResource by lazy { init__3_vayikra_08_txt() }

  internal val _3_vayikra_09_txt: AssetResource by lazy { init__3_vayikra_09_txt() }

  internal val _3_vayikra_10_txt: AssetResource by lazy { init__3_vayikra_10_txt() }

  internal val _3_vayikra_11_txt: AssetResource by lazy { init__3_vayikra_11_txt() }

  internal val _3_vayikra_12_txt: AssetResource by lazy { init__3_vayikra_12_txt() }

  internal val _3_vayikra_13_txt: AssetResource by lazy { init__3_vayikra_13_txt() }

  internal fun values(): List<AssetResource> = listOf(_38_divrei_hayamim_a_29_txt,
      _39_divrei_hayamim_b_01_txt, _39_divrei_hayamim_b_02_txt, _39_divrei_hayamim_b_03_txt,
      _39_divrei_hayamim_b_04_txt, _39_divrei_hayamim_b_05_txt, _39_divrei_hayamim_b_06_txt,
      _39_divrei_hayamim_b_07_txt, _39_divrei_hayamim_b_08_txt, _39_divrei_hayamim_b_09_txt,
      _39_divrei_hayamim_b_10_txt, _39_divrei_hayamim_b_11_txt, _39_divrei_hayamim_b_12_txt,
      _39_divrei_hayamim_b_13_txt, _39_divrei_hayamim_b_14_txt, _39_divrei_hayamim_b_15_txt,
      _39_divrei_hayamim_b_16_txt, _39_divrei_hayamim_b_17_txt, _39_divrei_hayamim_b_18_txt,
      _39_divrei_hayamim_b_19_txt, _39_divrei_hayamim_b_20_txt, _39_divrei_hayamim_b_21_txt,
      _39_divrei_hayamim_b_22_txt, _39_divrei_hayamim_b_23_txt, _39_divrei_hayamim_b_24_txt,
      _39_divrei_hayamim_b_25_txt, _39_divrei_hayamim_b_26_txt, _39_divrei_hayamim_b_27_txt,
      _39_divrei_hayamim_b_28_txt, _39_divrei_hayamim_b_29_txt, _39_divrei_hayamim_b_30_txt,
      _39_divrei_hayamim_b_31_txt, _39_divrei_hayamim_b_32_txt, _39_divrei_hayamim_b_33_txt,
      _39_divrei_hayamim_b_34_txt, _39_divrei_hayamim_b_35_txt, _39_divrei_hayamim_b_36_txt,
      _3_vayikra_01_txt, _3_vayikra_02_txt, _3_vayikra_03_txt, _3_vayikra_04_txt, _3_vayikra_05_txt,
      _3_vayikra_06_txt, _3_vayikra_07_txt, _3_vayikra_08_txt, _3_vayikra_09_txt, _3_vayikra_10_txt,
      _3_vayikra_11_txt, _3_vayikra_12_txt, _3_vayikra_13_txt)
}

private fun init__38_divrei_hayamim_a_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_38_divrei_hayamim_a-29.txt\")") as String, rawPath =
    "allChapters/_38_divrei_hayamim_a-29.txt")

private fun init__39_divrei_hayamim_b_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-01.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-01.txt")

private fun init__39_divrei_hayamim_b_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-02.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-02.txt")

private fun init__39_divrei_hayamim_b_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-03.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-03.txt")

private fun init__39_divrei_hayamim_b_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-04.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-04.txt")

private fun init__39_divrei_hayamim_b_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-05.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-05.txt")

private fun init__39_divrei_hayamim_b_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-06.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-06.txt")

private fun init__39_divrei_hayamim_b_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-07.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-07.txt")

private fun init__39_divrei_hayamim_b_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-08.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-08.txt")

private fun init__39_divrei_hayamim_b_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-09.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-09.txt")

private fun init__39_divrei_hayamim_b_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-10.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-10.txt")

private fun init__39_divrei_hayamim_b_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-11.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-11.txt")

private fun init__39_divrei_hayamim_b_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-12.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-12.txt")

private fun init__39_divrei_hayamim_b_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-13.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-13.txt")

private fun init__39_divrei_hayamim_b_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-14.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-14.txt")

private fun init__39_divrei_hayamim_b_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-15.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-15.txt")

private fun init__39_divrei_hayamim_b_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-16.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-16.txt")

private fun init__39_divrei_hayamim_b_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-17.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-17.txt")

private fun init__39_divrei_hayamim_b_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-18.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-18.txt")

private fun init__39_divrei_hayamim_b_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-19.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-19.txt")

private fun init__39_divrei_hayamim_b_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-20.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-20.txt")

private fun init__39_divrei_hayamim_b_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-21.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-21.txt")

private fun init__39_divrei_hayamim_b_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-22.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-22.txt")

private fun init__39_divrei_hayamim_b_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-23.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-23.txt")

private fun init__39_divrei_hayamim_b_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-24.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-24.txt")

private fun init__39_divrei_hayamim_b_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-25.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-25.txt")

private fun init__39_divrei_hayamim_b_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-26.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-26.txt")

private fun init__39_divrei_hayamim_b_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-27.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-27.txt")

private fun init__39_divrei_hayamim_b_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-28.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-28.txt")

private fun init__39_divrei_hayamim_b_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-29.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-29.txt")

private fun init__39_divrei_hayamim_b_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-30.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-30.txt")

private fun init__39_divrei_hayamim_b_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-31.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-31.txt")

private fun init__39_divrei_hayamim_b_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-32.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-32.txt")

private fun init__39_divrei_hayamim_b_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-33.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-33.txt")

private fun init__39_divrei_hayamim_b_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-34.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-34.txt")

private fun init__39_divrei_hayamim_b_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-35.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-35.txt")

private fun init__39_divrei_hayamim_b_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_39_divrei_hayamim_b-36.txt\")") as String, rawPath =
    "allChapters/_39_divrei_hayamim_b-36.txt")

private fun init__3_vayikra_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-01.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-01.txt")

private fun init__3_vayikra_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-02.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-02.txt")

private fun init__3_vayikra_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-03.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-03.txt")

private fun init__3_vayikra_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-04.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-04.txt")

private fun init__3_vayikra_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-05.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-05.txt")

private fun init__3_vayikra_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-06.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-06.txt")

private fun init__3_vayikra_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-07.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-07.txt")

private fun init__3_vayikra_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-08.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-08.txt")

private fun init__3_vayikra_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-09.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-09.txt")

private fun init__3_vayikra_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-10.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-10.txt")

private fun init__3_vayikra_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-11.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-11.txt")

private fun init__3_vayikra_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-12.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-12.txt")

private fun init__3_vayikra_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-13.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-13.txt")

public actual val SharedRes.assets.allChapters._38_divrei_hayamim_a_29_txt: AssetResource
  get() = CommonMainAssets14._38_divrei_hayamim_a_29_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_01_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_01_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_02_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_02_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_03_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_03_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_04_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_04_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_05_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_05_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_06_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_06_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_07_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_07_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_08_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_08_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_09_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_09_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_10_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_10_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_11_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_11_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_12_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_12_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_13_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_13_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_14_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_14_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_15_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_15_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_16_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_16_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_17_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_17_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_18_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_18_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_19_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_19_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_20_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_20_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_21_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_21_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_22_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_22_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_23_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_23_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_24_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_24_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_25_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_25_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_26_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_26_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_27_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_27_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_28_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_28_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_29_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_29_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_30_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_30_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_31_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_31_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_32_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_32_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_33_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_33_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_34_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_34_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_35_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_35_txt

public actual val SharedRes.assets.allChapters._39_divrei_hayamim_b_36_txt: AssetResource
  get() = CommonMainAssets14._39_divrei_hayamim_b_36_txt

public actual val SharedRes.assets.allChapters._3_vayikra_01_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_01_txt

public actual val SharedRes.assets.allChapters._3_vayikra_02_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_02_txt

public actual val SharedRes.assets.allChapters._3_vayikra_03_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_03_txt

public actual val SharedRes.assets.allChapters._3_vayikra_04_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_04_txt

public actual val SharedRes.assets.allChapters._3_vayikra_05_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_05_txt

public actual val SharedRes.assets.allChapters._3_vayikra_06_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_06_txt

public actual val SharedRes.assets.allChapters._3_vayikra_07_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_07_txt

public actual val SharedRes.assets.allChapters._3_vayikra_08_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_08_txt

public actual val SharedRes.assets.allChapters._3_vayikra_09_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_09_txt

public actual val SharedRes.assets.allChapters._3_vayikra_10_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_10_txt

public actual val SharedRes.assets.allChapters._3_vayikra_11_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_11_txt

public actual val SharedRes.assets.allChapters._3_vayikra_12_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_12_txt

public actual val SharedRes.assets.allChapters._3_vayikra_13_txt: AssetResource
  get() = CommonMainAssets14._3_vayikra_13_txt
